import { Button, notification, Space } from '@honestica/ui-kit/src';
import { useOnMount } from '@hooks';
import { openSettingsLink } from '@launcher/utils';
import { EnvManager } from '@services/environment/environment.service';
import { getUser } from '@store/user/user.selector';
import { differenceInCalendarDays, parseISO } from 'date-fns';
import { Key } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export function useUserPasswordExpiration() {
  const user = useSelector(getUser);
  const { t } = useTranslation();

  const onUpdateSettings = (key: Key | undefined) => {
    notification.destroy(key);
    openSettingsLink({ url: `${EnvManager.getBaseUrlUm()}/second_factors` || '' });
  };

  const NOTIFICATION_DAYS_THRESHOLD = 30;

  useOnMount(() => {
    if (user.passwordExpirationDate) {
      const expirationDate = parseISO(user.passwordExpirationDate);
      const daysRemaining = differenceInCalendarDays(expirationDate, new Date());
      if (daysRemaining <= NOTIFICATION_DAYS_THRESHOLD) {
        const key = `open${Date.now()}`;
        const btn = (
          <Space>
            <Button type="primary" size="small" onClick={() => onUpdateSettings(key)}>
              {t('user.passwordExpired.button_link')}
            </Button>
          </Space>
        );

        notification.warning({
          message: (
            <Trans i18nKey="user.passwordExpired.message" values={{ count: daysRemaining }}></Trans>
          ),
          description: t('user.passwordExpired.description'),
          placement: 'topRight',
          style: {
            width: 420,
          },
          btn,
          key,
        });
      }
    }
  });
}
